
export const dialog = async (title: string, message?:string) => {
  const alert = document.createElement('ion-alert');
  alert.header = title;
  alert.message = message;
  alert.buttons = ['關閉'];
  document.body.appendChild(alert);
  await alert.present();

  const { role } = await alert.onDidDismiss();
  console.log('onDidDismiss resolved with role', role);
}